import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface WarningModalConfig {
  title?: string;
  message: string;
  icon?: 'warning' | 'error' | 'info' | 'success';
  showDetails?: boolean;
  details?: Array<{ label: string; value: string; type?: 'text' | 'badge' }>;
  primaryButton?: {
    text: string;
    action: string;
    icon?: string;
  };
  secondaryButton?: {
    text: string;
    action: string;
  };
  radioMode?: boolean;
  radioOptions?: Array<{ id: any; label: string; subLabel?: string }>;
  onRadioSelect?: (id: any) => void;
}

@Component({
  selector: 'app-warning-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './warning-modal.component.html',
  styleUrls: ['./warning-modal.component.scss']
})
export class WarningModalComponent {
  @Input() show = false;
  @Input() config: WarningModalConfig = {
    title: 'Warning',
    message: '',
    icon: 'warning'
  };
  @Output() close = new EventEmitter<void>();
  @Output() action = new EventEmitter<string>();
  selectedRadioId: any = null;

  onClose() {
    this.close.emit();
  }

  onAction(action: string) { 
    if (action === 'close') {
      this.close.emit();
    }else{
      this.action.emit(action);
    }
  }

  onRadioSelect(id: any) {
    this.selectedRadioId = id;
    if (this.config.onRadioSelect) {
      this.config.onRadioSelect(id);
    }
    this.onClose();
  }

  getIconPath(): string {
    switch (this.config.icon) {
      case 'error':
        return 'M10.29 3.86L1.82 18A2 2 0 0 0 3.54 21H20.46A2 2 0 0 0 22.18 18L13.71 3.86A2 2 0 0 0 10.29 3.86ZM12 9V13M12 17H12.01';
      case 'info':
        return 'M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 16V12M12 8H12.01';
      case 'success':
        return 'M22 11.08V12A10 10 0 1 1 5.68 3.49M22 4L12 14.01L9 11.01';
      default: // warning
        return 'M10.29 3.86L1.82 18A2 2 0 0 0 3.54 21H20.46A2 2 0 0 0 22.18 18L13.71 3.86A2 2 0 0 0 10.29 3.86ZM12 9V13M12 17H12.01';
    }
  }

  getIconColor(): string {
    switch (this.config.icon) {
      case 'error':
        return '#DC2626';
      case 'info':
        return '#3B82F6';
      case 'success':
        return '#10B981';
      default: // warning
        return '#F59E0B';
    }
  }

  getIconBackground(): string {
    switch (this.config.icon) {
      case 'error':
        return '#FEE2E2';
      case 'info':
        return '#DBEAFE';
      case 'success':
        return '#D1FAE5';
      default: // warning
        return '#FEF3C7';
    }
  }

  getBadgeClass(type: string): string {
    switch (type) {
      case 'error':
        return 'badge-error';
      case 'warning':
        return 'badge-warning';
      case 'success':
        return 'badge-success';
      case 'info':
        return 'badge-info';
      default:
        return 'badge-default';
    }
  }

  getPrimaryButtonClass(): string {
    if (this.config.icon === 'info') {
      return 'btn generic-btn primary';
    }
    return 'btn btn-primary';
  }
} 